import {EH_LOCATION_SLUGS_SET} from "../core/eh-location";

function isEhLocation(location_slug: string) {
  return EH_LOCATION_SLUGS_SET.has(location_slug);
}

export default isEhLocation;
